module.exports = __webpack_public_path__ + "lv.svg?4838077bfe980fe615358fdc5ce4af8b";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/lv.svg
// module id = 1479
// module chunks = 0